import React from 'react';
import { StrategyLists } from 'src/components/Strategy/Center/components/StrategyMapResults/components/StrategyLists';

const StrategyListMembers = ({ row }) => {
  const lists = row?.list_membership || [];

  if (!lists || lists.length === 0) {
    return null;
  }
  return <StrategyLists lists={lists} />;
  // // If only one list, show it normally
  // if (lists.length === 1) {
  //   const firstList = lists[0];
  //   return (
  //     <div className="flex items-center gap-1 overflow-hidden">
  //       <Link
  //         href={`/lists/my/${firstList.id}`}
  //         shallow={true}
  //         scroll={false}
  //         replace={false}
  //         prefetch={false}
  //         onClick={(e) => e.stopPropagation()}
  //         className="flex-shrink"
  //       >
  //         <div className="px-1.5 py-1 bg-neutral-100 rounded-full flex justify-center items-center gap-0.5 overflow-hidden">
  //           <div className="w-3 h-3 flex items-center justify-center flex-shrink-0">
  //             <Icon icon={faList} className="text-neutral-600" size="xs" />
  //           </div>
  //           <div className="text-center justify-start text-tertiary text-sm font-normal font-['Inter'] leading-none truncate max-w-[80px]">
  //             {firstList.name || 'Unnamed List'}
  //           </div>
  //         </div>
  //       </Link>
  //     </div>
  //   );
  // }

  // // If multiple lists, show count + "lists"
  // return (
  //   <div className="flex items-center gap-1 overflow-hidden">
  //     <div className="px-1.5 py-1 bg-neutral-100 rounded-full flex justify-center items-center gap-0.5">
  //       <div className="w-3 h-3 flex items-center justify-center flex-shrink-0">
  //         <Icon icon={faList} className="text-neutral-600" size="xs" />
  //       </div>
  //       <div className="text-center justify-start text-tertiary text-xs font-normal font-['Inter'] leading-none">
  //         {lists.length} lists
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default StrategyListMembers;
